import {useState} from 'react';
import update from 'immutability-helper';

const useSarasRegularDnDManager = (dndType, defaultSortMode) => {
    const [sortMode, setSortMode] = useState(defaultSortMode === undefined ? true : defaultSortMode);

    const onToggleSort = () => {
        setSortMode(!sortMode);
    }

    const isSortMode = () => {
        return sortMode;
    }

    const groupKeys = (groupData) => {
        return groupData ? groupData.ViewRowsKeys : [];
    }

    const getGroupRow = (groupRow, rowIndex) => {
        return {};
    }

    const getGroupRowsKeys = (groupRow) => {
        return [];
    }

    const onDragEnd = (viewData, rowKeys, result) => {
        if(!result || !result.source || !result.destination) return null;

        //move the row in local
        let sourceKey = rowKeys[result.source.index];
        let sourceRow = viewData[sourceKey];

        //it means moving within the same group
        let newRowKeys = update(rowKeys, {
            $splice: [
                [result.source.index, 1],
                [result.destination.index, 0, sourceKey],
            ],
        });

        let previousIndex = -1;
        let previousKey = null;
        let previousRow = null;

        if(result.destination.index > 0)
        {
            previousIndex = result.destination.index - 1;
        }

        if(previousIndex >= 0)
        {
            previousKey = newRowKeys[previousIndex];

            if(previousKey) previousRow = viewData[previousKey];
        }

        let dropResult = {rowKeys: newRowKeys, 
                            sourceRow: {
                                rowId: sourceRow.rId},
                            previousRow: {
                                rowId: previousRow ? previousRow.rId : 0}
                        }

        return dropResult;
    }

    //use toggle sort and is sort mode for image sorting, 
    //because dnd doesn't support sorting of the grid layout, 
    //this toggle will be used by image component to switch to list mode while sorting 
    //and once sorting is done it will switch back to grid layout
    const returnObj = {
        onToggleSort,
        isSortMode,
        onDragEnd,
        groupKeys,
        getGroupRowsKeys,
        getGroupRow,
        dndType
    }

    return returnObj;

}

export default useSarasRegularDnDManager